import anime from 'animejs';

export function buttonInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const content = ctx.querySelector('.puzzle-button__content');

  anime.set(el, { scaleX: 0, transformOrigin: '50% 50%' });
  anime.set(content, { opacity: 0, translateY: 20 });
}

export function buttonAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const content = ctx.querySelector('.puzzle-button__content');
  const tl = anime.timeline({ delay });

  tl.add({
    targets: el,
    scaleX: 1,
  }, 0)
    .add({
      targets: content,
      opacity: 1,
      translateY: 0,
      complete: () => {
        el.setAttribute('data-animated', '');
      },
    }, 300);

  return tl;
}

export function buttonAnimOut(el, isClose = false) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  el.removeAttribute('data-animated');
  const content = ctx.querySelector('.puzzle-button__content');
  const tl = anime.timeline();

  tl.add({
    targets: content,
    opacity: 0,
    translateY: 20,
  });
  if (!isClose) {
    tl.add({
      targets: el,
      scale: 0,
      easing: 'easeInOutQuint',
      duration: 800,
    }, 0);
  }

  return tl;
}
